import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Photo, Product } from '@app/core/interfaces';
import { environment } from '@env/environment';
import { ButtonModule } from 'primeng/button';
import { PrimeNG } from 'primeng/config';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileBeforeUploadEvent, FileRemoveEvent, FileSelectEvent, FileUpload, FileUploadEvent, FileUploadModule } from 'primeng/fileupload';
import { MessageModule } from 'primeng/message';
import { ProgressBarModule } from 'primeng/progressbar';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-product-photos-form',
  imports: [CommonModule, ButtonModule, FormsModule, MessageModule, FileUploadModule, ProgressBarModule],
  templateUrl: './product-photos-form.html'
})
export class ProductPhotosForm {
  @Input() product!: Product;
  @ViewChild('filesUpload') filesUpload!: FileUpload;

  private destroy$: Subject<any> = new Subject();
  
  protected readonly apiUrl: string = environment.apiUrl;

  isSendingDatas: boolean = false;

  files: File[] = [];

  totalSize : number = 0;

  totalSizePercent : number = 0;

  uploadedFiles: any[] = [];
  // uploadedPhotos: Photo[] = [];
  filesError: string = '';

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: PrimeNG, 
  ) { }

  onFilesSelect(event: FileSelectEvent) {
    if (event.files && event.files.length > 0) {
      for (let file of event.files) {
        if (this.filesUpload.maxFileSize && file.size > this.filesUpload.maxFileSize) {
          this.filesError = `${this.filesError ? '<br>' : ''}La limite de ${this.formatSize(this.filesUpload.maxFileSize)} est dépassée par le fichier <code>${file.name}</code>, avec une taille de ${this.formatSize(file.size)}.`;
        } else {
          this.files.push(file);
        }
      }
    }
  }

  onFilesClear(event: Event) {
    this.files = [];
  }

  onFilesRemove(event: FileRemoveEvent) {
    this.files = this.files.filter(f => f !== event.file);
  }

  onFilesUpload(event: FileUploadEvent) {
    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    if (event.originalEvent instanceof HttpResponse) {
      // this.uploadedPhotos.push(...(event.originalEvent.body as Photo[]));

      this.hideDialog()
    }
  }

  formatSize(bytes: any) {
    const k = 1024;
    const dm = 3;
    const sizes = this.config.translation.fileSizeTypes as string[];
    if (bytes === 0) {
        return `0 ${sizes[0]}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${formattedSize} ${sizes[i]}`;
  }

  hideDialog(): void {
    this.isSendingDatas = false;
    this.dialogRef.close(null);
  }

  onSubmit(): void {
    this.isSendingDatas = true;
    this.uploadPhotos();
  }

  uploadPhotos() {
      this.filesUpload.url = `${this.apiUrl}/produits/${this.product.id}/photos`;
      this.filesUpload.uploader();
  }
}
